const routes = [
  {
    path: '/progress/stipulation5',
    name: 'progressStipulation5',
    component: () => import('@/views/progress/stipulation5/Main.vue'),
  },
  {
    path: '/progress/stipulation6',
    name: 'progressStipulation6',
    component: () => import('@/views/progress/stipulation6/Main.vue'),
  },
  {
    path: '/progress/stipulation15',
    name: 'progressStipulation15',
    component: () => import('@/views/progress/stipulation15/Main.vue'),
  },
  {
    path: '/progress/stipulation34',
    name: 'progressStipulation34',
    component: () => import('@/views/progress/stipulation34/Main.vue'),
  },
  {
    path: '/progress/stipulation40',
    name: 'progressStipulation40',
    component: () => import('@/views/progress/stipulation40/Main.vue'),
  },
  {
    path: '/progress/stipulation43',
    name: 'progressStipulation43',
    component: () => import('@/views/progress/stipulation43/Main.vue'),
  },
  {
    path: '/progress/stipulation49',
    name: 'progressStipulation49',
    component: () => import('@/views/progress/stipulation49/Main.vue'),
  },
  {
    path: '/progress/stipulation51',
    name: 'progressStipulation51',
    component: () => import('@/views/progress/stipulation51/Main.vue'),
  },
  {
    path: '/progress/stipulation6163',
    name: 'progressStipulation6163',
    component: () => import('@/views/progress/stipulation61_63/Main.vue'),
  },
  {
    path: '/progress/stipulation36',
    name: 'progressStipulation36',
    component: () => import('@/views/progress/stipulation36/Main.vue'),
  },
  {
    path: '/progress/stipulation42-1',
    name: 'progressStipulation42-1',
    component: () => import('@/views/progress/stipulation42-1/Main.vue'),
  },
  {
    path: '/progress/stipulation42-2',
    name: 'progressStipulation42-2',
    component: () => import('@/views/progress/stipulation42-2/Main.vue'),
  },
  {
    path: '/progress/stipulation44',
    name: 'progressStipulation44',
    component: () => import('@/views/progress/stipulation44/Main.vue'),
  },
  {
    path: '/progress/stipulation54',
    name: 'progressStipulation54',
    component: () => import('@/views/progress/stipulation54/Main.vue'),
  },
  {
    path: '/progress/stipulation55',
    name: 'progressStipulation55',
    component: () => import('@/views/progress/stipulation55/Main.vue'),
  },
  {
    path: '/progress/stipulation85',
    name: 'progressStipulation85',
    component: () => import('@/views/progress/stipulation85/Main.vue'),
  },
  {
    path: '/progress/stipulation86',
    name: 'progressStipulation86',
    component: () => import('@/views/progress/stipulation86/Main.vue'),
  },
  {
    path: '/progress/stipulation78',
    name: 'progressStipulation78',
    component: () => import('@/views/progress/stipulation78/Main.vue'),
  },
]

export default routes
